import { createIcon } from "@chakra-ui/react";
export const PlayArrowFilled = createIcon({
  displayName: "PlayArrowFilled",
  viewBox: "0 -960 960 960",
  d: "M356.001-311.474v-337.052q0-15.087 9.801-23.741 9.8-8.654 22.867-8.654 4.084 0 8.564 1.308t8.682 3.794l259.16 169.281q7.23 4.938 11.346 11.768 4.115 6.83 4.115 14.931 0 8.102-4.115 14.932-4.116 6.83-11.346 11.445L405.9-284.057q-4.215 2.489-8.852 3.733-4.636 1.245-8.851 1.245-12.903 0-22.549-8.654-9.647-8.654-9.647-23.741z",
});
